// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"efc39370","903":"2438f683"}[chunkId] + ".chunk.js";
};